import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

// Hooks
import { useAuth } from '@/hooks/useAuth';
import { routes } from '@/routes/routes';

export function StrictlyPublicRoute({ children }) {
  const router = useRouter();
  const { status, authStatuses } = useAuth();
  const [isLoggedOut, setIsLoggedOut] = useState(false);

  useEffect(() => {
    const handleRedirect = async () => {
      if (status === authStatuses.SIGNED_OUT || status === authStatuses.PENDING) {
        setIsLoggedOut(true);
      } else if (status === authStatuses.SIGNED_IN) {
        const isShopping = localStorage.getItem('cartItems');

        if (isShopping) {
          const shoppingData = JSON.parse(isShopping);
          const path = shoppingData.path?.split('?')[0];
          router.replace({
            pathname: path,
            query: { id: shoppingData.productId, showModal: true },
          });
        } else {
          sessionStorage.removeItem('brandAmbassadorId');
          router.push(routes.agreements.path);
        }
      }
    };

    handleRedirect();
  }, [router, status, authStatuses]);

  if (isLoggedOut) {
    return children;
  } else {
    return null;
  }
}
